const sectionHeader = {
  title: 'Calendario',
  description:
    'Organiza tus actividades y mantente al tanto de tus clases, evaluaciones y eventos importantes.'
};

export default { sectionHeader };
